import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { GET_GRAPHIC_SUPPLIERS_CURSOR } from "graphql/query/graphic-gql";

import Graphic from "components/graphic";
import Icons from "components/icons";
import { useActiveMenuItem, useBreadCrumbs, useMe } from "components/use-hooks";
import { PageWrapDefault, Tables } from "components/layout";
import Localize, { localizeByKey } from "components/service/localize";
import { gqlBuilderWhere } from "common/utils";
import { IFilter } from 'components/graphic/helpers/graphic-types-helper';
import { PermissionButton } from "components/permissions/components/permission-button";
import { usePageNavbarPermissions } from "components/permissions/hooks/use-page-navbar-permissions";
import VariableConst from "components/variable/variable-const";
import GraphicConst from "components/graphic/graphic-const";
import "./graphic.scss";

const basePath = Graphic.Const.basePath;
const tableHelper = Graphic.Helpers.TableMain;


const GraphicsPage: React.FC = () =>
{
  useActiveMenuItem([ "variable-lists" ], [ "variable-lists" ]);

  const breadcrumbs = [
    {
      label: localizeByKey("BREADCRUMBS.Label_GraphicRules"),
      path: `${basePath}`,
    },
  ];

  useBreadCrumbs(breadcrumbs);

  const { me } = useMe();
  const isDeveloper = me?.roles?.some((role: any) => role.slug === 'role_developer');

  const pageNavbar = [
    {
      label: localizeByKey("NAVBAR_PAGES.Label_VariableLists"),
      path: "variable-lists",
      permission: VariableConst.permissions.VIEW,
    },
    {
      label: localizeByKey("NAVBAR_PAGES.Label_GraphicRules"),
      path: "graphic-rules",
      permission: GraphicConst.permissions.VIEW,
    },
    ...(isDeveloper ? [ {
      label: localizeByKey("NAVBAR_PAGES.Label_Permissions"),
      path: "permissions",
    } ] : []),
  ];

  const { filteredNavbarItems } = usePageNavbarPermissions({ navbarItems: pageNavbar });

  const navigate = useNavigate();

  const objOrderBy = [ { column: "ID", order: "DESC" } ];

  const [ searchText, setSearchText ] = useState<string>("");
  const [ filters, setFilters ] = useState<IFilter | undefined>();
  const [ resetSorting, setResetSorting ] = useState<{ column: string; order: "ASC" | "DESC" }[]>();

  const graphicFilters = JSON.parse(localStorage.getItem("graphicFilters") || "{}");
  const graphicsSorting = JSON.parse(localStorage.getItem("graphicsSorting") || "{}");

  const objectFilters = filters || gqlBuilderWhere(graphicFilters);

  return (
    <PageWrapDefault
      className="page-graphics"
      dataExist={true}
      title={<Localize>PAGES.Title_Settings</Localize>}
      pageNavbar={filteredNavbarItems}
      staticPath=""
    >
      <Tables.Cursor
        model="graphicSuppliersCursor"
        query={GET_GRAPHIC_SUPPLIERS_CURSOR}
        varSet={{ perPage: 50 }}
        routeUrl={`${basePath}`}
        searchText={searchText}
        tableHelper={tableHelper}
        objectWhere={objectFilters}
        objOrderBy={graphicsSorting || objOrderBy}
        sortingName="graphicsSorting"
        resetSorting={resetSorting}
      >
        <div className="table-action-bar">
          <div className="col">
            <Graphic.Filters.Table
              {...{
                setSearchText,
                filters,
                setFilters,
                graphicFilters,
                setResetSorting,
                objOrderBy,
              }}
            />
          </div>

          <div className="col">
            <PermissionButton
              permission={Graphic.Const.permissions.UPDATE}
              disabledFallback={true}
              type="primary"
              icon={<Icons.Plus />}
              onClick={() => navigate(`${basePath}/create`)}
            >
              <span className="ellipsis">
                <Localize>GLOBAL.Button_Text_CreateNew</Localize>
              </span>
            </PermissionButton>
          </div>
        </div>
      </Tables.Cursor>
    </PageWrapDefault>
  );
};

export default GraphicsPage;
